import muiWithStyles from '@material-ui/core/styles/withStyles.js'

export default (styles, options) => muiWithStyles(styles, { index: 1, ...options })
